import {ArenaGameFilterBase} from "./arena-game-filter-base";

export class StaticArenaGameFilter extends ArenaGameFilterBase{

}
